import React from "react";
import Utility from "./../../utilities/Utility";
import { updateDependencyName } from "./ImportModule";
export default class ImportElementEmbed extends React.Component {
    /**
     * Embedded popup inside dialog for importing element
     * @module ImportElementEmbed
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.tempFile = null;
    }

    componentDidMount() {
        this.tempFile = null;
        $(".error-display").hide();
        $(".progress-display").hide();
        $(".info-display").hide();
    }

    componentDidUpdate() {
        this.tempFile = null;
        $(".error-display").hide();
        $(".progress-display").hide();
        $(".info-display").hide();
    }

    componentWillUnmount() {
        this.tempFile = null;
    }

    
    /** 
     * Removes references to Application Variables in node config properties
     * For Modules imported into Common Module authoring mode
     * Includes inputs, outputs, matchOrder, outputTo, and arguments
     * @param {array} arr
    */

    scrubPropertyArray(arr) {
        var newArr = [];
        arr.forEach((n,i) => {
            if(Object.values(n).filter(p => typeof p === 'string').findIndex(e => e.includes("app.")) === -1) {
                newArr.push(n);
            }
        });
        return newArr;
    }

    /**
     * Empties string properties of nodes containing Application Variables
     * For Modules imported into Common Module authoring mode
     * Includes scriptProgress, transferDestination, transferReason, analystClass, moduleReference, & promptReference
     * @param {string} str 
     */

    scrubStringProp(str) {
            return str = str.includes("app.") ? "" : str;
    }

    /**
     * Removes all references to Application Variables from nodes
     * For Modules imported into Common Module authoring mode
     * @param {node} obj 
     */
    scrubAppVars(node) {
        if(node.props){

            const nodeProps = node.props;
            const nodeConfig = nodeProps.config;
            const nodeInputs = nodeConfig.inputs;
            const nodeOutputs = nodeConfig.outputs;
            const nodeText = nodeConfig.text;
            const nodeFunction = nodeConfig.function;

            var configKeys = Object.keys(nodeConfig);
            configKeys.forEach(k => {

                switch(k) {
                    case "inputs":
                        node.props.config.inputs = this.scrubPropertyArray(nodeInputs);
                        break;
                    case "outputs":
                        node.props.config.outputs = this.scrubPropertyArray(nodeOutputs);
                        break;
                    case "text":
                        var textKeys = Object.keys(nodeText);
                        textKeys.forEach(n => {
                                var textArray = nodeText[n].split(/({{app.[a-zA-Z._]+}}|{{app.[a-zA-Z._]+)/);
                                    textArray.forEach((e,i) => {
                                        if(e.includes("app.")){
                                            delete textArray[i];
                                        }
                                    });
                        nodeText[n] = textArray.join("");
                        });
                        break;
                    case "function":
                        var nodeArguments = nodeFunction.arguments;
                        var nodeFuncOutputs = nodeFunction.outputs;

                        if(nodeArguments && nodeArguments.length > 0) {
                            node.props.config.function.arguments = this.scrubPropertyArray(nodeArguments);
                        }
                        if(nodeFuncOutputs && nodeFuncOutputs.length > 0) {
                            node.props.config.function.outputs = this.scrubPropertyArray(nodeFuncOutputs);
                        }
                        break;
                    case "billing":
                        if(nodeConfig.billing.value && nodeConfig.billing.value.includes("app.")) {
                            nodeConfig.billing = {};
                        }
                        break;
                    case "customTag":
                        if(nodeConfig.customTag.value && nodeConfig.customTag.value.includes("app.")) {
                            nodeConfig.customTag = {};
                        }
                        break;
                    case "scriptProgress":
                        var str = nodeConfig.scriptProgress;
                            nodeConfig.scriptProgress = str ? this.scrubStringProp(str) : "";
                        break;
                       
                    case "transferDestination":
                        var str = nodeConfig.transferDestination;
                            nodeConfig.transferDestination = str ? this.scrubStringProp(str) : "";
                        break;
                    case "transferReason":
                        var str = nodeConfig.transferReason;
                            nodeConfig.transferReason = str ? this.scrubStringProp(str) : "";
                        break;
                    case "analystClass":
                        var str = nodeConfig.analystClass;
                            nodeConfig.analystClass = str ? this.scrubStringProp(str) : "";
                        break;
                    case "moduleReference":
                        var str = nodeConfig.moduleReference;
                            nodeConfig.moduleReference = str ? this.scrubStringProp(str) : "";
                        break;
                    case "promptReference":
                        var str = nodeConfig.promptReference;
                            nodeConfig.promptReference = str ? this.scrubStringProp(str) : "";
                        break;
                    case "matchOrder":
                        node.props.config.matchOrder = this.scrubPropertyArray(nodeConfig.matchOrder);
                        break;
                    case "outputTo":
                        node.props.config.outputTo = this.scrubPropertyArray(nodeConfig.outputTo);
                        break;

                }
            });
        // Empty all data access node schema ref, script, and variable properties
            if(node.props.nodeTypeName === "Data Access") {
                if(nodeConfig.variable){
                    nodeConfig.variable = "";
                }
                if(nodeConfig.schema){
                    nodeConfig.schema = "";
                }
                if(nodeConfig.customScript){
                    nodeConfig.customScript = "";
                }
            }
        //Scrub exit node custom headers
            if(nodeProps.nodeTypeName === "Module Exit") {
                const exitComp = nodeConfig.exitComponent;
                if(nodeConfig.type === "VARIABLE"){
                    if(nodeConfig.varName.includes('app.')) {
                        nodeConfig.varName = "";
                        nodeConfig.outputs = [{argumentName: null, 
                                                type: "VARIABLE", 
                                                value: null, 
                                                varName: null, 
                                                intent: null}
                        ];
                    }
                }
                if(exitComp){
                    const customHeaders = exitComp.customHeaders;
                    if(customHeaders && customHeaders.length > 0){
                        var newHeaders = [];
                        customHeaders.forEach(h => {
                            if(!h.value.includes('app.')){
                                newHeaders.push(h);
                            }
                        });
                        exitComp.customHeaders = newHeaders;
                    }
                }
            }
        // Scrub links
            if(nodeConfig.condition && nodeConfig.condition.length > 0) {
            
                var newConditionals = [];
                var newConditions = [];
                var orConditionalArray = nodeConfig.serializedCondition.split(/\s\|\|\s/);

                nodeConfig.condition.forEach(c => {
                    var conditionSet = [];
                    c.forEach(n => {
                        if(!n.includes("app.")) {
                            conditionSet.push(n);
                        }
                    });
                    if(conditionSet.length > 0) {
                        newConditions.push(conditionSet);
                    }
                        
                });
                node.props.config.condition = newConditions;

                orConditionalArray.forEach(n => {
            
                    if(n.includes("&&")) {
                        var newArray = []
                        var nsplit = n.split(" && ");
                        nsplit.forEach(e => {
                            var cleanElement = e.replace(/[^a-zA-Z._\s="]+/g,"");
                            if(cleanElement.includes("mod.") || cleanElement.includes("out ==")){
                                newArray.push("("+cleanElement+")");
                            }
                        });
                        if(newArray.length !== 0) {
                            var newjoin = newArray.join(" && ");
                            newConditionals.push("("+newjoin+")");
                        }
                    } else if(!n.includes("app.")) {
                        newConditionals.push(n);
                    }
                });
                nodeConfig.serializedCondition = newConditionals.length > 0 ? newConditionals.join(" || ") : "true";
            }
            
        }

        if(node.versions){
            const nodeFlow = node.versions[1].flow.nodes;
            const linkFlow = node.versions[1].flow.links;
            nodeFlow.forEach(n => {this.scrubAppVars(n)});
            linkFlow.forEach(n => {this.scrubAppVars(n)});
        }
    }

    // 
    /**
     * Initiate App Variables scrubbing on Module being imported into Common Module authoring mode
     * @param {object} obj 
     */

    scrubAppVarsInit(obj) {
        var newObj = [];
        this.scrubAppVars(obj.node);
        obj._dependencies.forEach(n => {
            if(n.type !== "variable" && n.type !== "schema" && n.type !== "function") {
                this.scrubAppVars(n.node);
                newObj.push(n);
            }
        });
        obj._dependencies = newObj;
    }

    /**
     * CORE-34512
     * Creates new unique id for incoming module. All internal references to old id are replaced with new id
     * @param {string} results 
     */

     newModuleId(results) {
        const resultsParsed = JSON.parse(results);
        const node = resultsParsed.node;
        const moduleId = node.id;
        const modRegex = new RegExp(moduleId, "g");
        const newModId = Utility.uuid4();
        const renamedNode = updateDependencyName(resultsParsed.node, "module");
        if(renamedNode){
            resultsParsed.node = renamedNode;
        }
        results = JSON.stringify(resultsParsed);
    
        return JSON.parse(results.replace(modRegex, newModId));
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        const isCommonModule = Utility.getIsCommonModule(window.apm.serialized);
        const appVarWarning = "<p style='color:var(--color-error);'>Warning: This module contains application variables. All references will be deleted upon import. Check all custom scripts for errors.</p>" + window.l.popup.click_to_import_element;
        return (
            <div>
                <div className={"container-fluid element-dialog element-body"}>
                    <div className={"row"}>
                        <div className={"col-md-12"}>
                            <p>{window.l.popup.upload_import_json}</p>
                        </div>
                        <div className="col-md-6">
                            <input type="file" name="fileField" style={{ margin: "10px 0" }}
                                onChange={event => {
                                    // Upload file
                                    const errorD = $(".error-display");
                                    const progD = $(".progress-display");
                                    const infoD = $(".info-display");
                                    errorD.html("").hide();
                                    infoD.html("").hide();
                                    progD.show();
                                    const file = event.currentTarget.files[0];
                                    if (!file) {
                                        progD.hide();
                                        errorD.html(window.l.popup.error_accessing_file).show();
                                        return;
                                    }
                                    // Read file
                                    const reader = new FileReader();
                                    reader.onload = (e) => {
                                        try {
                                            this.tempFile = null;
                                            if (JSON.parse(e.target.result).node.type !== "module") {
                                                progD.hide();
                                                errorD.html("Only modules are supported").show();
                                                return;
                                            }

                                            const importedModule = this.newModuleId(e.target.result);
                                            var clickToImport = window.l.popup.click_to_import_element;
                                            
                                            // has all required keys
                                            if (!importedModule.hasOwnProperty("node")) {
                                                progD.hide();
                                                errorD.html(window.l.popup.file_wrong_element_format).show();
                                                return;
                                            }

                                            if (isCommonModule) {
                                                this.scrubAppVarsInit(importedModule);
                                                clickToImport = e.target.result.includes("app.") ? appVarWarning : window.l.popup.click_to_import_element;
                                            }

                                            progD.hide();
                                            errorD.hide();
                                            this.tempFile = importedModule;
                                            infoD.html(
                                                "<h4>" + window.l.popup.element_info + "</h4>" +
                                                "<table class='table table-bordered'><tbody>" +
                                                "<tr><td>" + window.l.popup.name + "</td><td>" + importedModule.node.name + "</td></tr>" +
                                                "<tr><td>" + window.l.popup.type + "</td><td>" + importedModule.node.type + "</td></tr>" +
                                                "</tbody></table>" +
                                                clickToImport
                                            ).show();
                                        } catch (e) {
                                            // JSON
                                            progD.hide();
                                            errorD.html(window.l.popup.error_reading_file + e).show();
                                        }
                                    };
                                    reader.readAsText(file);
                                }}
                            />
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-md-12"}>
                            <div className={"progress-display"}>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped active" role="progressbar"
                                         aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"
                                         style={{width: "100%"}}>
                                        {window.l.popup.processing_file}
                                    </div>
                                </div>
                            </div>
                            <div className={"error-display text-danger"}>
                            </div>
                            <div className={"info-display"}>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"element-buttons"}>
                    <button className={"w2ui-btn secondary"} onClick={() => {
                        w2popup.message()
                    }}>{window.l.popup.close}
                    </button>

                    <button className={"w2ui-btn primary"} readOnly={(this.tempFile&&(_.filter(window.apm.serialized.components.modules, { name: this.props.exports.node.name })).length>0)} onClick={() => {
                        if (this.tempFile&&(_.filter(window.apm.serialized.components.modules, { name: this.tempFile.node.name })).length>0) {
                            w2popup.close();
                            return window.apm.notification.post("error", this.tempFile.node.name+window.l.notification.module_exists_in_application);
                        } else if(this.tempFile&&(_.filter(window.apm.serialized.components.modules, { name: this.tempFile.node.name })).length===0){
                            if(this.tempFile && this.tempFile.node._class === "PromptNodeModel"){
                                window.apm.knowlegdeBase.initializePromptChannelConfig(this.tempFile.node)
                            }
                            
                            const newNode = this.props.addFunc($('#tl_container'), this.tempFile);
                            if(newNode) {
                                window.apm.postEventToCurrentView({
                                    target: "request-component-panel",
                                    event: newNode,
                                    shouldFocusInput: true,
                                });
                            }
                        }else {
                            alert(window.l.popup.please_choose_file);
                        }
                    }}>{window.l.popup.import_element}
                    </button>

                </div>
            </div>
        );
    }
}